export enum PositionStatus {
    Published = 'PUBLISHED',
    Draft = 'DRAFT',
    Archived = 'ARCHIVED',
    Deleted = 'DELETED',
}
